import { react, useState,useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import Stack from '@mui/material/Stack';
import AlertDialog from '../Modals/AlertDialog'
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import GoogleMapsAutocomplete from '../GoogleMapsAutocomplete';
import TokenService from '../../services/TokenService';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import ErrorIcon from '@mui/icons-material/Error';
import AnnouncementIcon from '@mui/icons-material/Announcement';

export default function CustomerInformation(props) {
    //const [formErrors, setFormErrors] = useState([]);

    const [customerFirstname, setCustomerFirstname] = useState(props.pickupRequest.CustomerName !== undefined ? props.pickupRequest.CustomerName : '');
    const [customerLastname, setCustomerLastname] = useState(props.pickupRequest.CustomerLastname !== undefined ? props.pickupRequest.CustomerLastname : '');
    const [checkPayee, setCheckPayee] = useState(props.pickupRequest.CustomerCheckPayeeName !== undefined ? props.pickupRequest.CustomerCheckPayeeName : '');
    const [checkPayeeManuallyEntered, setCheckPayeeManuallyEntered] = useState('');
    const [checkPayeeModified, setCheckPayeeModified] = useState(false);
    const [customerEmail, setCustomerEmail] = useState(props.pickupRequest.CustomerEmail !== undefined ? props.pickupRequest.CustomerEmail : '');
    const [customerEmail2, setCustomerEmail2] = useState(props.pickupRequest.CustomerEmail !== undefined ? props.pickupRequest.CustomerEmail : '');
    const [customerPhoneNumber, setCustomerPhoneNumber] = useState(props.pickupRequest.CustomerPhoneNum !== undefined ? props.pickupRequest.CustomerPhoneNum : '');
    const [hasMobileUpdates, setHasMobileUpdates] = useState(props.pickupRequest.CustomerWantsTextMsg !== undefined ? props.pickupRequest.CustomerWantsTextMsg : true);
    const [customerAddressStreet, setCustomerAddressStreet] = useState(props.pickupRequest.CustomerAddress_Street !== undefined ? props.pickupRequest.CustomerAddress_Street : '');
    const [customerAddressStreet2, setCustomerAddressStreet2] = useState(props.pickupRequest.CustomerAddress_Apt_Suit_Other !== undefined ? props.pickupRequest.CustomerAddress_Apt_Suit_Other : '');
    const [customerAddressCity, setCustomerAddressCity] = useState(props.pickupRequest.CustomerAddress_City !== undefined ? props.pickupRequest.CustomerAddress_City : '');
    const [customerAddressState, setCustomerAddressState] = useState(props.pickupRequest.CustomerAddress_State !== undefined ? props.pickupRequest.CustomerAddress_State : '');
    const [customerAddressZip, setCustomerAddressZip] = useState(props.pickupRequest.CustomerAddress_Zipcode !== undefined ? props.pickupRequest.CustomerAddress_Zipcode : '');
    const [isLoading, setIsLoading] = useState(false);
    const [latitude, setLatitude] = useState(props.pickupRequest.Latitude !== undefined ? props.pickupRequest.Latitude : 0);
    const [longitude, setLongitude] = useState(props.pickupRequest.Longitude !== undefined ? props.pickupRequest.Longitude : 0);

    const [isFormValid, setIsFormValid] = useState(false);
    const prevCustomerPhoneNumber = useRef();

    let _allowBlankFields = useRef(true);


    const [formErrors, setFormErrors] = useState([]);

    const [alertDialog, setAlertDialog] = useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });

    useEffect(() => {
        //assign the ref's current value to the count Hook
        prevCustomerPhoneNumber.current = customerPhoneNumber;
    }, [customerPhoneNumber]); //run this code when the value of customerPhoneNumber changes

    function isValidated() {

        let isValid = true;
        let errors = [];
        if (customerFirstname.trim() == '') {
            if (!_allowBlankFields.current) {
                errors["Firstname"] = "Missing your First Name";
            }

            isValid = false;
        }

        if (customerLastname.trim() == '') {
            if (!_allowBlankFields.current) {
                errors["Lastname"] = "Missing your Last Name";
            }
            isValid = false;
        }

        if (props.pickupRequest.CustomerPaymentMethod === 'Digital Check' || props.pickupRequest.CustomerPaymentMethod === 'Mailed Check') {
            if (checkPayeeModified && checkPayeeManuallyEntered.trim() === '') {
                if (!_allowBlankFields.current) {
                    errors["CheckPayee"] = "Who do we make the check out to?";
                }
                isValid = false;
            }
        }

        if (customerEmail.trim() === '') {
            if (!_allowBlankFields.current) {
                errors["EmailAddress"] = "Missing your Email";
            }
            isValid = false;
        }
        else {
            if (!isValidEmail(customerEmail.trim())) {
                isValid = false;
                if (!_allowBlankFields.current) {
                    // don't show this error until they click Next
                    errors["EmailAddress"] = "Not a valid email.";
                }

            }
            else {
                if (customerEmail.trim().toLowerCase().indexOf('@gmail.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@gmail.com') == -1) {
                    isValid = false;
                    if (!_allowBlankFields.current) {
                        // don't show this error until they click Next
                        errors["EmailAddress"] = "Did you mean @gmail.com?";
                    }
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@yahoo.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@yahoo.com') == -1) {
                    isValid = false;
                    if (!_allowBlankFields.current) {
                        // don't show this error until they click Next
                        errors["EmailAddress"] = "Did you mean @yahoo.com?";
                    }
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@hotmail.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@hotmail.com') == -1) {
                    isValid = false;
                    if (!_allowBlankFields.current) {
                        // don't show this error until they click Next
                        errors["EmailAddress"] = "Did you mean @hotmail.com?";
                    }
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@aol.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@aol.com') == -1) {
                    isValid = false;
                    if (!_allowBlankFields.current) {
                        // don't show this error until they click Next
                        errors["EmailAddress"] = "Did you mean @aol.com?";
                    }
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@comcast.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@comcast.net') == -1) {
                    isValid = false;
                    if (!_allowBlankFields.current) {
                        // don't show this error until they click Next
                        errors["EmailAddress"] = "Did you mean @comcast.net?";
                    }
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@sbcglobal.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@sbcglobal.net') == -1) {
                    isValid = false;
                    if (!_allowBlankFields.current) {
                        // don't show this error until they click Next
                        errors["EmailAddress"] = "Did you mean @sbcglobal.net?";
                    }
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@icloud.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@icloud.com') == -1) {
                    isValid = false;
                    if (!_allowBlankFields.current) {
                        // don't show this error until they click Next
                        errors["EmailAddress"] = "Did you mean @icloud.com?";
                    }
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@outlook.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@outlook.com') == -1) {
                    isValid = false;
                    if (!_allowBlankFields.current) {
                        // don't show this error until they click Next
                        errors["EmailAddress"] = "Did you mean @outlook.com?";
                    }
                }
                else if (customerEmail.trim().toLowerCase().indexOf('@msn.') > -1 &&
                    customerEmail.trim().toLowerCase().indexOf('@msn.com') == -1) {
                    isValid = false;
                    if (!_allowBlankFields.current) {
                        // don't show this error until they click Next
                        errors["EmailAddress"] = "Did you mean @msn.com?";
                    }
                }

            }
        }

        if (customerEmail2.trim() === '') {
            if (!_allowBlankFields.current) {
                errors["EmailAddress2"] = "Please re-enter your email";
            }
            isValid = false;
        }

        if (customerEmail.trim() !== '' && customerEmail2.trim() !== '') {
            if (customerEmail.trim().toUpperCase() !== customerEmail2.trim().toUpperCase()) {
                errors["EmailAddress2"] = "Emails do not match";
                isValid = false;
            }
        }

        if (customerPhoneNumber.trim() === '') {
            if (!_allowBlankFields.current) {
                errors["PhoneNumber"] = "Please enter your phone number";
            }
            isValid = false;
        }
        else if (customerPhoneNumber.trim().length !== 14) {
            if (!_allowBlankFields.current) {
                errors["PhoneNumber"] = "Enter your 10 digit phone number";
            }
            isValid = false;
        }

        if (customerAddressStreet.trim() === '') {
            if (!_allowBlankFields.current) {
                errors["CustomerAddressStreet"] = "Please enter your Street";
            }
            isValid = false;
        }


        return {
            isValid: isValid,
            errors: errors
        }
    }

    function normalizePhoneNumber(value, previousValue) {
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');
        const cvLength = currentValue.length;

        //if (!previousValue)// || value.length > previousValue.length)
        {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;

            if (currentValue.length == 11 && currentValue.indexOf('1') == 0) {
                // remove leading '1'
                return `(${currentValue.slice(1, 4)}) ${currentValue.slice(4, 7)}-${currentValue.slice(7, 11)}`;
            }

            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };

    function setPhoneNumberChanged(val) {
        let phone = normalizePhoneNumber(val, prevCustomerPhoneNumber.current);
        setCustomerPhoneNumber(phone);
    }

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    function setCheckPayeeChanged(val) {
        setCheckPayeeManuallyEntered(val);
        setCheckPayeeModified(true);
    }

    function firstNameUpdated(val) {
        setCustomerFirstname(val);
        if (checkPayeeManuallyEntered.trim() === '') {
            setCheckPayee(val + ' ' + customerLastname);
        }
    }

    function lastNameUpdated(val) {
        setCustomerLastname(val);
        if (checkPayeeManuallyEntered.trim() === '') {
            setCheckPayee((customerFirstname + ' ' + val).trim());
        }
    }

    function finalValidation() {
        _allowBlankFields.current = false;
        let validationResult = isValidated();
        if (validationResult.isValid) {

            // send for verification
            let value = {
                emailAddress: customerEmail.trim(),
                phoneNumber: customerPhoneNumber
            }
            let postData = {
                value: JSON.stringify(value)
            }
            setIsLoading(true);
            TokenService.post(postData, 'VerifyCustomer', '')
                .then((response) => {
                    setIsLoading(false);
                    if (response !== null) {
                        let isValid = true;
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            if (response.JsonData != '') {
                                let jsonData = JSON.parse(response.JsonData);
                                let handled = false;

                                if (jsonData.Ban !== undefined) {
                                    if (typeof jsonData.Ban === 'string') {
                                        jsonData.Ban = JSON.parse(jsonData.Ban);
                                    }
                                    if (jsonData.Ban.BanType == 'Hard') {
                                        // no need to consider notes, just show a No Service prompt
                                        handled = true;
                                        isValid = false;
                                        setAlertDialog({
                                            show: true,
                                            title: '',
                                            canClose: false,
                                            message:
                                                <div style={{ display: 'flex' }}>
                                                    <ErrorIcon sx={{ color: 'var(--sipzee-red)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                                                    <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                                                        <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>We apologize but we are not currently offering service at this time.</div>
                                                    </div>
                                                </div>,
                                            
                                        });
                                    }
                                }
                                if (!handled && jsonData.Note !== undefined) {
                                    isValid = false;
                                    if (typeof jsonData.Note === 'string') {
                                        jsonData.Note = JSON.parse(jsonData.Note);
                                    }
                                    setAlertDialog({
                                        show: true,
                                        canClose:true,
                                        title: '',
                                        message:
                                            <div style={{ display: 'flex' }}>
                                                <AnnouncementIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                                                <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                                                    <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>{jsonData.Note.Note}</div>
                                                </div>
                                            </div>,
                                        closeButton: 'Acknowledge',
                                    });
                                }
                            }
                        }

                        if (isValid) {
                            props.onNext(
                                customerFirstname.trim(),
                                customerLastname.trim(),
                                (checkPayeeModified ? checkPayeeManuallyEntered.trim() : checkPayee.trim()),
                                customerEmail.trim(),
                                customerPhoneNumber,
                                hasMobileUpdates,
                                customerAddressStreet,
                                customerAddressStreet2,
                                customerAddressCity,
                                customerAddressState,
                                customerAddressZip,
                                latitude,
                                longitude
                            );
                        }
                    }
                })
                .catch((response) => {
                    //error occurred? Don't stop the customer's order
                    setIsLoading(false);
                    props.onNext(
                        customerFirstname.trim(),
                        customerLastname.trim(),
                        (checkPayeeModified ? checkPayeeManuallyEntered.trim() : checkPayee.trim()),
                        customerEmail.trim(),
                        customerPhoneNumber,
                        hasMobileUpdates,
                        customerAddressStreet,
                        customerAddressStreet2,
                        customerAddressCity,
                        customerAddressState,
                        customerAddressZip,
                        latitude,
                        longitude
                    );
                });

            //firstName, lastName, checkPayee, emailAddress, phoneNumber, receiveSMSUpdates, street1, street2, city, state, zip

        }
        else {
            // update any field to cause us to re-render
            setFormErrors(validationResult.errors);
        }

    }

    function setAddressFromGoogleData(googleData) {
        if (googleData !== null) {
            // last 3 items in googleData.terms are Country, State, City. Put everything else as the Street
            let streetAddress = '';
            if (googleData !== null) {
                if (googleData.terms.length > 3) {
                    for (let i = 0; i < googleData.terms.length - 3; i++) {
                        streetAddress += googleData.terms[i].value + " ";
                    }
                    streetAddress = streetAddress.trim();
                    setCustomerAddressStreet(streetAddress);
                    setCustomerAddressCity(googleData.terms[googleData.terms.length - 3].value);
                    setCustomerAddressState(googleData.terms[googleData.terms.length - 2].value);
                    setCustomerAddressZip(props.pickupData.ZipCodeInfo.Zipcode);
                    setLatitude(googleData.latitude);
                    setLongitude(googleData.longitude);
                }
                else {
                    setCustomerAddressCity('');
                    setCustomerAddressState('');
                }
            }

        }
    }

    function showMoreInfo(infoType) {
        if (infoType == 'Email') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>Email</div>
                            <div style={{ marginTop: '10px' }}>The email address you would like us to use to provide updates on your request. </div>
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }
        else if (infoType == 'PhoneNumber') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>Phone Number</div>
                            <div style={{ marginTop: '10px' }}>Only used if the Recycler needs to contact you. </div>
                            <div style={{ marginTop: '10px' }}>You can optionally select if you want to receive Text/SMS updates about your order. </div>
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }

    }

    let formValidation = isValidated();
    let checkPayeeSection = null;
    if (props.pickupRequest.CustomerPaymentMethod === 'Digital Check' || props.pickupRequest.CustomerPaymentMethod === 'Mailed Check') {

        checkPayeeSection =
            <div className={styles.ContactSection}>
                <div className={styles.ContactSectionHeader}>Check Payee</div>
                <div className={styles.ContactSectionBody}>
                    <TextField className={styles.ContactSectionText} error={formValidation.errors['CheckPayee'] !== undefined} label="Pay to the Order Of" onChange={(e) => setCheckPayeeChanged(e.target.value)} value={(checkPayeeModified ? checkPayeeManuallyEntered : checkPayee)} variant="outlined" />
                    <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CheckPayee'] !== undefined ? formValidation.errors['CheckPayee'] : ''}</div>
                </div>
            </div>
    }

    function buildLoadingPanel() {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="50px"
            >
                <CircularProgress color="secondary" />
            </Box>
        )

    }

    return (
        <div className='CustomerInformationPanel' style={{ maxWidth: '450px', marginLeft: 'auto', marginRight: 'auto' }}>
            <div className={styles.cardHeader}>Contact Information</div>
            {isLoading ? buildLoadingPanel()
                :
                <>
                    <div className={styles.ContactSection}>
                        <div className={styles.ContactSectionHeader}>
                            <span>Name</span>

                        </div>
                        <div className={styles.ContactSectionBody}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['Firstname'] !== undefined} label="First Name" onChange={(e) => firstNameUpdated(e.target.value)} value={customerFirstname} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Firstname'] !== undefined ? formValidation.errors['Firstname'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['Lastname'] !== undefined} label="Last Name" onChange={(e) => lastNameUpdated(e.target.value)} value={customerLastname} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Lastname'] !== undefined ? formValidation.errors['Lastname'] : ''}</div>
                        </div>
                    </div>

                    {checkPayeeSection}

                    <div className={styles.ContactSection}>
                        <div className={styles.ContactSectionHeader}>
                            <span>Email</span>
                            <IconButton aria-label="More Info" onClick={() => showMoreInfo('Email')} tabIndex={-1} style={{ marginRight: '10px' }}>
                                <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                            </IconButton>
                        </div>
                        <div className={styles.ContactSectionBody}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['EmailAddress'] !== undefined} label="Email" onChange={(e) => setCustomerEmail(e.target.value)} value={customerEmail} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['EmailAddress'] !== undefined ? formValidation.errors['EmailAddress'] : ''}</div>
                            {props.pickupRequest.CustomerPaymentMethod !== 'Digital Check' ? null :
                                <div style={{ fontStyle: 'italic' }}>Your digital check will be emailed to this address.</div>
                            }
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['EmailAddress2'] !== undefined} label="Re-Enter Email" onChange={(e) => setCustomerEmail2(e.target.value)} value={customerEmail2} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['EmailAddress2'] !== undefined ? formValidation.errors['EmailAddress2'] : ''}</div>
                        </div>
                    </div>

                    <div className={styles.ContactSection}>
                        <div className={styles.ContactSectionHeader}>
                            <span>Phone Number</span>
                            <IconButton aria-label="More Info" onClick={() => showMoreInfo('PhoneNumber')} tabIndex={-1} style={{ marginRight: '10px' }}>
                                <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                            </IconButton>
                        </div>
                        <div className={styles.ContactSectionBody}>
                            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', minWidth: '330px' }}>
                                <TextField style={{ width: '200px', alignSelf: 'flex-start' }} className={styles.ContactSectionText} error={formValidation.errors['PhoneNumber'] !== undefined} label="Phone Number" onChange={(e) => setPhoneNumberChanged(e.target.value)} value={customerPhoneNumber} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />

                                <div style={{ textAlign: 'center', alignSelf: 'flex-start', marginLeft: '5px' }}>

                                    <StyledCheckbox style={{ marginTop: '-15px' }} checked={hasMobileUpdates} onChange={(e) => setHasMobileUpdates(e.target.checked)} />
                                    <div>
                                        Receive Text Updates?
                                    </div>
                                </div>
                            </div>
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['PhoneNumber'] !== undefined ? formValidation.errors['PhoneNumber'] : ''}</div>
                        </div>

                    </div>

                    <div className={styles.ContactSection}>
                        <div className={styles.ContactSectionHeader}>
                            <span>Pickup Address</span>

                        </div>
                        <div className={styles.ContactSectionBody}>
                            <GoogleMapsAutocomplete className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressStreet'] !== undefined} label="Start typing your address..." onSelected={(googleData) => setAddressFromGoogleData(googleData)} value={customerAddressStreet} variant="outlined" />
                            {/* <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressStreet'] !== undefined} label="Street" onChange={(e) => setCustomerAddressStreet(e.target.value)} value={customerAddressStreet} variant="outlined" />*/}
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressStreet'] !== undefined ? formValidation.errors['CustomerAddressStreet'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressStreet2'] !== undefined} label="Apt/Suite/Other" onChange={(e) => setCustomerAddressStreet2(e.target.value)} value={customerAddressStreet2} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressStreet2'] !== undefined ? formValidation.errors['CustomerAddressStreet2'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressCity'] !== undefined} label="City" onChange={(e) => setCustomerAddressCity(e.target.value)} value={customerAddressCity} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressCity'] !== undefined ? formValidation.errors['CustomerAddressCity'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressState'] !== undefined} label="State" onChange={(e) => setCustomerAddressState(e.target.value)} value={customerAddressState} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressState'] !== undefined ? formValidation.errors['CustomerAddressState'] : ''}</div>
                        </div>
                        <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                            <TextField className={styles.ContactSectionText} error={formValidation.errors['CustomerAddressZip'] !== undefined} label="Zip" onChange={(e) => setCustomerAddressZip(e.target.value)} value={customerAddressZip} variant="outlined" />
                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['CustomerAddressZip'] !== undefined ? formValidation.errors['CustomerAddressZip'] : ''}</div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                        <div style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}>
                            <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                            <Button variant={formValidation.isValid ? "contained" : "outlined"} color="sipzeeGreen" onClick={() => finalValidation()}>Next <KeyboardArrowRight /></Button>
                        </div>
                    </div>

                    <AlertDialog isShown={alertDialog.show} close={() => setAlertDialog({ show: false })} Title={alertDialog.title} Message={alertDialog.message} canClose={alertDialog.canClose}  CloseText={alertDialog.closeButton} />
                </>
            }
        </div>
        
    );
} 